module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a5-4-2b22a9a3f1ae466c8471efd00afb4de7.jpg";